import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on route change, or to anchor when location.hash is set.
// Uses a bounded retry loop so hash-targets inside lazy-loaded sections
// (e.g. /random-acts#wall) get scrolled to as soon as they mount, without
// racing against the initial render.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      let tries = 0;
      const maxTries = 30; // ~1.5s max wait for lazy content
      const attempt = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        if (tries++ < maxTries) setTimeout(attempt, 50);
        else window.scrollTo({ top: 0, behavior: "instant" });
      };
      // start slightly after mount so React has time to render the current route.
      setTimeout(attempt, 60);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);
  return null;
}
